import { render, staticRenderFns } from "./Event-Card.vue?vue&type=template&id=22294ed0&scoped=true&"
import script from "./Event-Card.vue?vue&type=script&lang=js&"
export * from "./Event-Card.vue?vue&type=script&lang=js&"
import style0 from "./Event-Card.vue?vue&type=style&index=0&id=22294ed0&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22294ed0",
  null
  
)

export default component.exports